import React, { useContext } from "react";

import { HistoryEventInfo } from "@features/offer/desktop/event/info-header/HistoryEventInfo";
import { OfferOptionsContext } from "@gp/components";
import { EventOffer } from "@gp/offer";

import { LiveEventInfo } from "./LiveEventInfo";
import { PrematchEventInfo } from "./PrematchEventInfo";

export function EventFullInfoSelector(props: { event: EventOffer }) {
	const offerOptionsContext = useContext(OfferOptionsContext);
	// @ts-expect-error
	if (offerOptionsContext.isHistoryEvent?.(props.event.id) ?? false) {
		return <HistoryEventInfo event={props.event} />;
	}
	if (props.event.isLive) {
		return <LiveEventInfo event={props.event} />;
	}

	return <PrematchEventInfo event={props.event} />;
}
